export default __webpack_public_path__ + "static/media/accountIcon.e1fca05d.svg";